import React from "react";
import "./automatedLeadCapturing.css";
import automated_lead_capturing1 from "assets/awards/automated_lead_capturing1.png";
import automated_lead_capturing2 from "assets/awards/automated_lead_capturing2.jpg";
import automated_lead_capturing3 from "assets/awards/automated_lead_capturing3.png";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

const AutomatedLeadCapturing = () => {
  const navigate = useNavigate();
  
  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };
  return (
    <div className="automated-lead-container">
      <div className="automated-lead-top-heading">
        <h1>Easier Real Estate Lead Management with Real Estate CRM</h1>
        <p>
          With sale automation, managing lead has always been a time-consuming
          and energy-draining task for sales representatives. Not anymore. With
          real estate advance lead management software, most of the work gets
          done automatically and the rest, at the click of a button !
        </p>
        <button onClick={handleGetDemo} className="marketingAutomation-btn">
          GET A DEMO
        </button>
      </div>
      <div className="row">
        <div className="col-12 automated-lead-col">
          <div className="col-3">
            <div className="right-side-heading">
              <h2>Broker Inventory Management</h2>
              <Link
                to="automatically-capture-leads"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Automatically capture leads
              </Link>
              <Link
                to="property-portals"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Integrate with Property Portals
              </Link>
              <Link
                to="avoid-leads-leakage"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Avoid leads leakage & duplication
              </Link>
            </div>
          </div>
          <div className="col-9">
            <div
              className="automated-lead-section"
              id="automatically-capture-leads"
            >
              <div className="automated-lead-heading">
                <h2>Automatically capture leads from multiple sources</h2>
                <p>
                  Real Estate lead forms can be easily integrated into all your
                  digital assets. This lead data is then automatically gathered
                  in one place for your easy viewing & tracking.
                </p>
                <p>
                  Lets you capture leads from all media like Live Chat, SMS,
                  emails, calls and website
                </p>
              </div>
              <div className="automated-lead-img">
                <img src={automated_lead_capturing1} alt="" />
              </div>
            </div>
            <div className="automated-lead-section" id="property-portals">
              <div className="automated-lead-heading">
                <h2>Integrate with Property Portals</h2>
                <p>
                  Being a platform designed exclusively for Real Estate, Realtor
                  Real Estate comes with in-built real estate portal
                  integrations. So, you don’t have to visit each platform
                  separately to manage data or get an overview of performance.
                  And, you don’t have to pay additional costs for this feature,
                  unlike popular CRMs.
                </p>
                <p>
                  Every developer has a presence on property portals, but you
                  need not undertake complicated routing or interventions to
                  gather data from these channels - you can simply integrate
                  your portals with Realtor Real Estate so that your leads flow
                  automatically in your account in real time.
                </p>
              </div>
              <div className="automated-lead-img">
                <img src={automated_lead_capturing2} alt="" />
              </div>
            </div>
            <div className="automated-lead-section" id="avoid-leads-leakage">
              <div className="automated-lead-heading">
                <h2>Avoid leads leakage & duplication</h2>
                <p>
                  As the name suggests, lead duplication is the situation when a
                  lead enters your system more than once. It’s not intentional
                  in most cases but lead duplication often happens because of
                  improper formatting, misspellings, incomplete records, lead
                  entering data more than once, responding to different services
                  or products, small variations, etc.
                </p>
                <p>
                  Validate data by preventing leads leakage and entering of
                  duplicate information
                </p>
              </div>
              <div className="automated-lead-img">
                <img src={automated_lead_capturing3} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomatedLeadCapturing;
